export default __webpack_public_path__ + "static/media/cancelIcon.b42a74bc.svg";